import { Box, IconButton, Button, Typography, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useAuth } from "../../AuthContext";
import { tokens } from "../../theme";
import { ToastContainer, toast } from "react-toastify";
import { Form } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import 'react-toastify/dist/ReactToastify.css';
import Nodata from '../../assets/errors/nodata.png';
import QRCode from "qrcode";
import logo from "../../assets/logo.png";
import QrCodeIcon from '@mui/icons-material/QrCode';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';

const Inventory = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [staffs, setStaffs] = useState([]);
  const [validAssets, setValidAssets] = useState([]);
  const [loaning, setLoaning] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { getData, addData, updateData, deleteData } = useAuth();

  // Form state
  const [formData, setFormData] = useState({
    invoiceNumber: "",
    sku: "",
    type:'purchased',
    description: '',
    category: "",
    categoryType: "",
    verification_period: 'weekly',
    location: "Windhoek STEAM Centre",
    serialNumber: "",
    purchaseddate: new Date().toISOString().split('T')[0],
    suplier: '',
    quantity: '0',
    deliveredDate: '',
    currentPeriodEnd: '',
    lifeSpanPeriod: '10',
    broaght_in_use: '',
    depreciationMethod: 'straight_line',
    depreciationRate: '10',
    costprice: '0',
    additions: '0',
    actualValue: '0',
    salvageValue: '0',
    depreciationValue: '0',
    opening_depr: '0',
    current_period_depr: '0',
    accumulated_depr: '0',
    carrying_value: '0',
    book_value: '0',
    product_condition: 'New',
    deliveredStatus: '0',
    comment: '',
    assignedTo: "",
    isVerified: '0',
    verifiedDate: new Date().toISOString().split('T')[0],
    status: '0'
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getData('proccess.php', 'inventory'); // Fetch inventory data
        if (response.success) {
          setItems(Array.isArray(response.data) ? response.data : []);
        } else {
          toast.error(response.message || "Failed to load asset data");
        }

        const validAssetsResponse = await getData("proccess.php", "inventory");
        if (validAssetsResponse.success) {
          const validItems = Array.isArray(validAssetsResponse.data)
            ? validAssetsResponse.data.filter(
                (item) =>
                  !["discarded", "damaged", "refurbished"].includes(
                    (item.product_condition || "").toLowerCase()
                  )
              )
            : [];
          setValidAssets(validItems);
        }

        const staffsResponse = await getData("proccess.php", "staffs");
        if (staffsResponse.success) {
          setStaffs(
            Array.isArray(staffsResponse.data) ? staffsResponse.data : []
          );
        } else {
            //toast.error(staffsResponse.message || "Failed to load staffs data");
        }

        const loaningResponse = await getData("proccess.php", "loaning");
        if (loaningResponse.success) {
          setLoaning(
            Array.isArray(loaningResponse.data) ? loaningResponse.data : []
          );
        } else {
            //toast.error(loaningResponse.message || "Failed to load loaning data");
        } 

      } catch (err) {
        toast.error("Network error: Failed to fetch asset data");
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]);

  const downloadSkuQR = async (item) => {
    try {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const width = 400;
      const height = 500;

      canvas.width = width;
      canvas.height = height;

      // white background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, width, height);

      // load logo
      const logoImg = new Image();
      logoImg.src = logo;

      logoImg.onload = async () => {

        // draw logo
        const logoSize = 305;
        ctx.drawImage(
          logoImg,
          (width - logoSize) / 2,
          20,
          logoSize,
          75
        );

        // generate QR
        const qrDataUrl = await QRCode.toDataURL(item.sku, {
          margin: 1,
          width: 250,
        });

        const qrImg = new Image();
        qrImg.src = qrDataUrl;

        qrImg.onload = () => {

          const qrSize = 250;

          ctx.drawImage(
            qrImg,
            (width - qrSize) / 2,
            120,
            qrSize,
            qrSize
          );

          // SKU text
          ctx.fillStyle = "#000";
          ctx.font = "bold 28px Arial";
          ctx.textAlign = "center";

          ctx.fillText(
            item.sku,
            width / 2,
            430
          );

          // download PNG
          const link = document.createElement("a");
          link.download = `${item.sku}_qr.png`;
          link.href = canvas.toDataURL("image/png");
          link.click();
        };
      };
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate QR code");
    }
  };

  const generateSKU = () => {
    const prefix = "STEAM";

    if (!items || items.length === 0) {
      return `${prefix}000001`;
    }

    // Extract numeric parts from existing SKUs
    const numbers = items
      .map(item => item.sku)
      .filter(Boolean)
      .map(sku => parseInt(sku.replace(prefix, "")))
      .filter(num => !isNaN(num));

    const maxNumber = numbers.length > 0 ? Math.max(...numbers) : 0;

    const nextNumber = maxNumber + 1;

    return `${prefix}${String(nextNumber).padStart(6, "0")}`;
  };

  const handleAddClick = () => {
    setFormData({
      invoiceNumber: '',
      sku: generateSKU(),
      type: 'purchased',
      description: '',
      category: "",
      categoryType: "",
      verification_period: 'weekly',
      location: "Windhoek STEAM Centre",
      serialNumber: "",
      purchaseddate: new Date().toISOString().split('T')[0],
      suplier: '',
      quantity: 0,
      deliveredDate: '',
      currentPeriodEnd: '',
      lifeSpanPeriod: 10,
      broaght_in_use: '',
      depreciationMethod: 'straight_line',
      depreciationRate: 10,
      costprice: 0,
      additions: 0,
      actualValue: 0,
      salvageValue: 0,
      depreciationValue: 0,
      opening_depr: 0,
      current_period_depr: 0,
      accumulated_depr: 0,
      carrying_value: 0,
      book_value: 0,
      product_condition: '',
      deliveredStatus: 0,
      comment: '',
      assignedTo: "",
      isVerified: 0,
      verifiedDate: new Date().toISOString().split('T')[0],
      status: 0,

      // Missing fields added
      image: '',
      lastDepreciationDate: '',
      nextDepreciationDate: '',
      dateCreated: new Date().toISOString()
    });

    setOpenAddDialog(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);

    setFormData({
      invoiceNumber: item.invoiceNumber ?? '',
      sku: item.sku ?? '',
      type: item.type ?? 'purchased',
      description: item.description ?? '',
      category: item.category ?? '',
      categoryType: item.categoryType ?? '',
      verification_period: item.verification_period ?? 'weekly',
      location: item.location ?? '',
      serialNumber: item.serialNumber ?? '',
      purchaseddate: item.purchaseddate ?? new Date().toISOString().split('T')[0],
      suplier: item.suplier ?? '',
      quantity: item.quantity ?? 0,
      deliveredDate: item.deliveredDate ?? '',
      currentPeriodEnd: item.currentPeriodEnd ?? '',
      lifeSpanPeriod: item.lifeSpanPeriod ?? 10,
      broaght_in_use: item.broaght_in_use ?? '',
      depreciationMethod: item.depreciationMethod ?? 'straight_line',
      depreciationRate: item.depreciationRate ?? 10,
      costprice: item.costprice ?? 0,
      additions: item.additions ?? 0,
      actualValue: item.actualValue ?? 0,
      salvageValue: item.salvageValue ?? 0,
      depreciationValue: item.depreciationValue ?? 0,
      opening_depr: item.opening_depr ?? 0,
      current_period_depr: item.current_period_depr ?? 0,
      accumulated_depr: item.accumulated_depr ?? 0,
      carrying_value: item.carrying_value ?? 0,
      book_value: item.book_value ?? 0,
      product_condition: item.product_condition ?? '',
      deliveredStatus: item.deliveredStatus ?? 0,
      comment: item.comment ?? '',
      assignedTo: item.assignedTo ?? '',
      isVerified: item.isVerified ?? 0,
      verifiedDate: item.verifiedDate ?? '',
      status: item.status ?? 0,

      // Missing fields (IMPORTANT)
      image: item.image ?? '',
      lastDepreciationDate: item.lastDepreciationDate ?? '',
      nextDepreciationDate: item.nextDepreciationDate ?? '',
      dateCreated: item.dateCreated ?? ''
    });

    setOpenEditDialog(true);
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setOpenDeleteDialog(true);
  };

  const handleAssetsDownload = async () => {
    try {      
      const response = await getData('proccess.php', 'inventory'); // Fetch inventory data
      if (response.success) {
        const validItems = Array.isArray(response.data)
          ? response.data.filter(
              (item) =>
                !["discarded", "damaged", "refurbished"].includes(
                  (item.product_condition || "").toLowerCase()
                )
            )
          : [];
        setValidAssets(validItems);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch asset data");
      return;
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await deleteData('proccess.php', 'inventory', itemToDelete.id); // Delete inventory item by ID
      if (response.success) {
        toast.success(`Asset item deleted successfully`);
        setItems(items.filter(item => item.id !== itemToDelete.id));
      } else {
        toast.error(response.message || "Failed to delete asset item");
      }
    } catch (err) {
      toast.error("Network error: Failed to delete asset item");
      console.error("Delete error:", err);
    }
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "0" : "1") : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      let response;
      let salvage = (formData.costprice - (formData.costprice * (formData.depreciationRate / 100))) || 0;
      let depreciationValue = (formData.costprice - salvage) / formData.lifeSpanPeriod;
      
      if (selectedItem) {
        let actualValue = 0;
        // Update existing inventory item
        if (formData.actualValue <= 0){
          actualValue = formData.costprice;
        } else {
          actualValue = formData.actualValue - depreciationValue;
        }

        formData.salvageValue = salvage; // make sure it is an integer
        formData.depreciationValue = depreciationValue; // make sure it is an integer
        formData.actualValue = actualValue; // make sure it is an integer

        response = await updateData('proccess.php', 'inventory', formData, selectedItem.id); // Update inventory item
        if (response.success) {
          toast.success(`Asset item updated successfully`);
          setItems(response.data);
          handleAssetsDownload();
        }
      } else {
        // Add new inventory item
          let actualValue = 0;
          if (depreciationValue <= 0){
            actualValue = formData.costprice;
          } else {
            actualValue = formData.costprice;
          }

        formData.salvageValue = salvage; // make sure it is an integer
        formData.depreciationValue = depreciationValue; // make sure it is an integer
        formData.actualValue = actualValue; // make sure it is an integer

        response = await addData('proccess.php', 'inventory', formData); // Add inventory item
        if (response.success) {
          toast.success(`Asset item added successfully`);
          setItems(response.data); // Assuming response.data contains the new item
          handleAssetsDownload();
        }
      }

      if (!response.success) {
        toast.error(response.message || "Operation failed");
      }
    } catch (err) {
      toast.error("Network error: Operation failed");
      console.error("Operation error:", err);
    }
    setOpenEditDialog(false);
    setOpenAddDialog(false);
    setSelectedItem(null);
  };

  // Export to Excel function
  const exportToExcel = () => {
    if (validAssets.length === 0) {
      toast.warning("No data to export");
      return;
    }

    try {
      // Create CSV content
      const headers = [
        'ID',
        'Invoice Number',
        'SKU',
        'type',
        'description',
        'category',
        'Category Type',
        'verification_period',
        'Location',
        'Serial Number',
        'Purchased Date',
        'Supplier',
        'Quantity',
        'Delivered Date',
        'Current Period End',
        'Life Span Period',
        'Brought In Use',
        'Depreciation Method',
        'Depreciation Rate (%)',
        'Cost Price (N$)',
        'Additions (N$)',
        'Actual Value (N$)',
        'Salvage Value (N$)',
        'Depreciation Value (N$)',
        'Opening Depreciation',
        'Current Period Depreciation',
        'Accumulated Depreciation',
        'Carrying Value',
        'Book Value',
        'Condition',
        'Delivered Status',
        'Status',
        'Comment',
        'Assigned To',
        'Is Verified',
        'Verified Date',
        'Date Created'
      ];

      const csvContent = validAssets.map(item => [
        item.id,
        `"${item.invoiceNumber || ''}"`,
        `"${item.sku || ''}"`,
        `"${item.type || ''}"`,
        `"${item.description || ''}"`,
        `"${item.category || ''}"`,
        `"${item.categoryType || ''}"`,
        `"${item.verification_period || ''}"`,
        `"${item.location || ''}"`,
        `"${item.serialNumber || ''}"`,
        `"${item.purchaseddate || ''}"`,
        `"${item.suplier || ''}"`,
        item.quantity || '0',
        `"${item.deliveredDate || ''}"`,
        `"${item.currentPeriodEnd || ''}"`,
        `"${item.lifeSpanPeriod > 1 ? item.lifeSpanPeriod + " Years" : item.lifeSpanPeriod + " Year" || ''}"`,
        `"${item.broaght_in_use || ''}"`,
        `"${item.depreciationMethod || ''}"`,
        item.depreciationRate || '0',
        item.costprice || '0',
        item.additions || '0',
        item.actualValue || '0',
        item.salvageValue || '0',
        item.depreciationValue || '0',
        item.opening_depr || '0',
        item.current_period_depr || '0',
        item.accumulated_depr || '0',
        item.carrying_value || '0',
        item.book_value || '0',
        `"${item.product_condition || ''}"`,
        `"${getDeliveredStatusText(item.deliveredStatus)}"`,
        `"${getStatusText(item.status)}"`,
        `"${item.comment || ''}"`,
        `"${item.assignedTo || ''}"`,
        `"${item.isVerified === 0 ? 'Yes' : 'No'}"`,
        `"${item.verifiedDate || ''}"`,
        `"${item.dateCreated || ''}"`
      ].join(','));

      // Combine headers and data
      const xlsxContent = [headers.join(','), ...csvContent].join('\n');

      // Create and download file
      const blob = new Blob([xlsxContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `inventory_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      toast.success("Inventory data exported successfully");
    } catch (error) {
      console.error('Export error:', error);
      toast.error("Failed to export data");
    }
  };

  // Export to Excel function
  const exportAccountingExcel = () => {
    if (validAssets.length === 0) {
      toast.warning("No data to export");
      return;
    }

    try {
      // Group assets by category
      const groupedAssets = validAssets.reduce((groups, asset) => {
        const category = asset.category || 'Uncategorized';
        if (!groups[category]) {
          groups[category] = [];
        }
        groups[category].push(asset);
        return groups;
      }, {});

      // Define audit-relevant fields only
      const auditFields = [
        { key: 'description', label: 'Description', width: 30 },
        { key: 'id', label: 'Identification Number', width: 20 },
        { key: 'sku', label: 'Asset SKU', width: 15 },
        { key: 'lifeSpanPeriod', label: 'Years', width: 20 },
        { key: 'currentPeriodEnd', label: 'Date', width: 20 },
        { key: 'costprice', label: 'Cost (N$)', width: 12 },
        { key: 'additions', label: 'Additions (N$)', width: 12 },
        { key: 'actualValue', label: 'Closing Cost (N$)', width: 12 },
        { key: 'salvageValue', label: 'Residual Value (N$)', width: 12 },
        { key: 'depreciationValue', label: 'Depreciable Amount (N$)', width: 12 },
        { key: 'opening_depr', label: 'Opening Depreciation', width: 12 },
        { key: 'current_period_depr', label: 'Current Period Depreciation', width: 12 },
        { key: 'accumulated_depr', label: 'Accumulated Depreciation', width: 12 },
        { key: 'carrying_value', label: 'Carrying Value (N$)', width: 12 },
        { key: 'book_value', label: 'Book Value (N$)', width: 12 },
      ];

      // Create HTML content with styling
      const getStatusText = (status) => {
        const statusMap = { 0: 'Active', 1: 'Inactive', 2: 'Disposed', 3: 'Under Maintenance' };
        return statusMap[status] || 'Unknown';
      };

      const getVerificationStatus = (isVerified) => {
        return isVerified === 0 ? '✓ Verified' : '✗ Pending';
      };

      const formatDate = (date) => {
        if (!date) return '-';
        return new Date(date).toLocaleDateString();
      };

      const formatCurrency = (value) => {
        if (!value && value !== 0) return '-';
        return `N$ ${parseFloat(value).toFixed(2)}`;
      };

      // Build HTML table with styling
      let htmlContent = `
        <html>
        <head>
          <meta charset="UTF-8">
          <style>
            * { font-family: 'Segoe UI', Arial, sans-serif; }
            
            /* Main Header Style */
            .main-header {
              background-color: #1B4F72;
              color: white;
              font-size: 14px;
              font-weight: bold;
              text-align: center;
              padding: 12px;
            }
            
            /* Category Header Style */
            .category-header {
              background-color: #2874A6;
              color: white;
              font-size: 13px;
              font-weight: bold;
              text-align: left;
              padding: 8px 10px;
            }
            
            /* Sub-table Header Style */
            .sub-header {
              background-color: #5DADE2;
              color: white;
              font-size: 11px;
              font-weight: bold;
              text-align: center;
              padding: 6px;
            }
            
            /* Data Row Styles */
            .data-row {
              background-color: #FFFFFF;
              font-size: 10px;
            }
            
            .data-row-alt {
              background-color: #F2F3F4;
              font-size: 10px;
            }
            
            /* Cell Styles */
            td, th {
              border: 1px solid #BDC3C7;
              padding: 6px 8px;
              text-align: left;
            }
            
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .text-left { text-align: left; }
            
            /* Status colors */
            .status-active { color: #27AE60; font-weight: bold; }
            .status-inactive { color: #E74C3C; }
            .status-disposed { color: #7F8C8D; }
            .verified-yes { color: #27AE60; font-weight: bold; }
            .verified-no { color: #E74C3C; }
            
            /* Summary Row */
            .summary-row {
              background-color: #D5DBDB;
              font-weight: bold;
              font-size: 11px;
            }
            
            /* Asset count badge */
            .asset-count {
              background-color: #F39C12;
              color: white;
              padding: 2px 8px;
              border-radius: 12px;
              font-size: 11px;
              margin-left: 10px;
            }
            
            table {
              border-collapse: collapse;
              width: 100%;
              margin-bottom: 20px;
            }
          </style>
        </head>
        <body>
          <h2 style="color: #1B4F72; margin-bottom: 5px;">AUDIT REPORT - FIXED ASSETS REGISTER</h2>
          <p style="color: #7F8C8D; margin-top: 0; margin-bottom: 20px;">
            Generated: ${new Date().toLocaleString()} | Total Assets: ${validAssets.length}
          </p>
      `;

      // Calculate totals
      let grandTotalCost = 0;
      let grandTotalCurrent = 0;
      let grandTotalDepreciation = 0;

      // Generate tables for each category
      for (const [category, assets] of Object.entries(groupedAssets)) {
        // Calculate category totals
        const categoryTotalCost = assets.reduce((sum, a) => sum + (parseFloat(a.costprice) || 0), 0);
        const categoryTotalCurrent = assets.reduce((sum, a) => sum + (parseFloat(a.actualValue) || 0), 0);
        const categoryTotalDep = assets.reduce((sum, a) => sum + (parseFloat(a.depreciationValue) || 0), 0);
        
        grandTotalCost += categoryTotalCost;
        grandTotalCurrent += categoryTotalCurrent;
        grandTotalDepreciation += categoryTotalDep;

        htmlContent += `
          <table>
            <!-- Category Header -->
            <tr>
              <td colspan="${auditFields.length}" class="category-header">
                📁 ${category.toUpperCase()} 
                <span class="asset-count">${assets.length} Assets</span>
              </td>
            </tr>
            
            <!-- Sub-table Headers -->
            <tr>
        `;
        
        // Add column headers
        auditFields.forEach(field => {
          htmlContent += `<th class="sub-header">${field.label}</th>`;
        });
        
        htmlContent += `</tr>`;
        
        // Add data rows
        assets.forEach((asset, index) => {
          const rowClass = index % 2 === 0 ? 'data-row' : 'data-row-alt';
          htmlContent += `<tr class="${rowClass}">`;
          
          auditFields.forEach(field => {
            let value = '';
            let cellClass = '';
            
            switch (field.key) {
              case 'sku':
                value = asset.sku || '-';
                break;
              case 'description':
                value = asset.description || '-';
                break;
              case 'serialNumber':
                value = asset.serialNumber || '-';
                break;
              case 'location':
                value = asset.location || '-';
                break;
              case 'supplier':
                value = asset.suplier || '-';
                break;
              case 'purchaseddate':
                value = formatDate(asset.purchaseddate);
                cellClass = 'text-center';
                break;
              case 'costprice':
                value = formatCurrency(asset.costprice);
                cellClass = 'text-right';
                break;
              case 'actualValue':
                value = formatCurrency(asset.actualValue);
                cellClass = 'text-right';
                break;
              case 'depreciationValue':
                value = formatCurrency(asset.depreciationValue);
                cellClass = 'text-right';
                break;
              case 'quantity':
                value = asset.quantity || '0';
                cellClass = 'text-center';
                break;
              case 'product_condition':
                value = asset.product_condition || 'Good';
                break;
              case 'status':
                const statusText = getStatusText(asset.status);
                const statusClass = asset.status === 0 ? 'status-active' : (asset.status === 1 ? 'status-inactive' : '');
                value = `<span class="${statusClass}">${statusText}</span>`;
                break;
              case 'assignedTo':
                value = asset.assignedTo || 'Not Assigned';
                break;
              case 'isVerified':
                const verifiedClass = asset.isVerified === 0 ? 'verified-yes' : 'verified-no';
                value = `<span class="${verifiedClass}">${getVerificationStatus(asset.isVerified)}</span>`;
                cellClass = 'text-center';
                break;
              case 'verifiedDate':
                value = formatDate(asset.verifiedDate);
                cellClass = 'text-center';
                break;
              default:
                value = '-';
            }
            
            htmlContent += `<td class="${cellClass}">${value}</td>`;
          });
          
          htmlContent += `</tr>`;
        });
        
        // Add category summary row
        htmlContent += `
          <tr class="summary-row">
            <td colspan="4" style="text-align: right; font-weight: bold;">CATEGORY TOTALS →</td>
            <td colspan="2" style="text-align: right;">Total Cost: ${formatCurrency(categoryTotalCost)}</td>
            <td style="text-align: right;">Total Current: ${formatCurrency(categoryTotalCurrent)}</td>
            <td style="text-align: right;">Total Dep: ${formatCurrency(categoryTotalDep)}</td>
            <td colspan="${auditFields.length - 8}"></td>
          </tr>
        `;
        
        htmlContent += `</table><br/>`;
      }
      
      // Add grand total summary
      htmlContent += `
        <table style="margin-top: 20px;">
          <tr style="background-color: #1B4F72; color: white; font-weight: bold;">
            <td colspan="${auditFields.length}" style="text-align: center; font-size: 13px;">
              GRAND TOTALS - ALL ASSETS
            </td>
          </tr>
          <tr style="background-color: #E8E8E8; font-weight: bold;">
            <td colspan="4" style="text-align: right;">Total Cost Value:</td>
            <td colspan="3">${formatCurrency(grandTotalCost)}</td>
            <td colspan="${auditFields.length - 7}"></td>
          </tr>
          <tr style="background-color: #F5F5F5; font-weight: bold;">
            <td colspan="4" style="text-align: right;">Total Current Value:</td>
            <td colspan="3">${formatCurrency(grandTotalCurrent)}</td>
            <td colspan="${auditFields.length - 7}"></td>
          </tr>
          <tr style="background-color: #E8E8E8; font-weight: bold;">
            <td colspan="4" style="text-align: right;">Total Depreciation:</td>
            <td colspan="3">${formatCurrency(grandTotalDepreciation)}</td>
            <td colspan="${auditFields.length - 7}"></td>
          </tr>
          <tr style="background-color: #D5DBDB; font-weight: bold;">
            <td colspan="4" style="text-align: right;">Net Book Value:</td>
            <td colspan="3">${formatCurrency(grandTotalCurrent)}</td>
            <td colspan="${auditFields.length - 7}"></td>
          </tr>
        </table>
        
        <div style="margin-top: 30px; padding: 10px; background-color: #F9EBEA; border-left: 4px solid #E74C3C; font-size: 10px;">
          <strong>Audit Notes:</strong><br/>
          • ✓ Verified = Asset has been physically verified<br/>
          • ✗ Pending = Asset requires verification<br/>
          • All values are in Namibian Dollars (N$)<br/>
          • Report generated on: ${new Date().toLocaleString()}
        </div>
      </body></html>`;

      // Create and download Excel file (using HTML table format which Excel can open)
      const blob = new Blob([htmlContent], { 
        type: 'application/vnd.ms-excel' 
      });
      
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `audit_report_${new Date().toISOString().split('T')[0]}.xls`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      toast.success(`Audit report exported with ${validAssets.length} assets across ${Object.keys(groupedAssets).length} categories`);
    } catch (error) {
      console.error('Export error:', error);
      toast.error("Failed to export audit report");
    }
  };

  // Export to Excel function
  const exportPPEExcel  = () => {
    if (validAssets.length === 0) {
      toast.warning("No PPE data to export");
      return;
    }

    try {
      // Get financial year parameters
      const currentYearEnd = new Date(); // Current date
      const previousYearEnd = new Date();
      previousYearEnd.setFullYear(previousYearEnd.getFullYear() - 1);
      
      // You can set specific year-end date here
      const financialYearEndDate = new Date(2026, 2, 30); // 30 March 2026
      const previousPeriodDate = new Date(2025, 3, 21); // 21 April 2025
      
      const formatDisplayDate = (date) => {
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
      };
      
      const currentPeriodEnd = formatDisplayDate(financialYearEndDate);
      const previousPeriodEnd = formatDisplayDate(previousPeriodDate);

      // Group assets by category and calculate totals per category
      const categoryMovements = validAssets.reduce((categories, asset) => {
        let category = asset.category || 'Other PPE';
        
        // Categorize PPE types
        if (asset.type === 'property') category = 'Property - Buildings & Land';
        else if (asset.type === 'plant') category = 'Plant & Machinery';
        else if (asset.type === 'equipment') category = 'Equipment - IT & Office';
        else if (asset.type === 'furniture') category = 'Furniture & Fixtures';
        else if (asset.type === 'vehicles') category = 'Motor Vehicles';
        else if (asset.type === 'tools') category = 'Tools & Equipment';
        else category = `Other Assets - ${category}`;
        
        if (!categories[category]) {
          categories[category] = {
            openingBalance: 0,
            additions: 0,
            depreciation: 0,
            disposals: 0,
            transfers: 0,
            closingBalance: 0
          };
        }
        
        // Calculate movements for this asset
        const openingBalance = (parseFloat(asset.actualValue) + parseFloat(asset.depreciationValue)) || 0;
        const additions = parseFloat(asset.costprice) || 0;
        const depreciation = parseFloat(asset.depreciationValue) || 0;
        const disposals = (asset.status === 1 || asset.status === 'disposed') ? openingBalance : 0;
        const transfers = 0; // Add transfer logic if needed
        const closingBalance = parseFloat(asset.actualValue) || 0;
        
        categories[category].openingBalance += openingBalance;
        categories[category].additions += additions;
        categories[category].depreciation += depreciation;
        categories[category].disposals += disposals;
        categories[category].transfers += transfers;
        categories[category].closingBalance += closingBalance;
        
        return categories;
      }, {});

      // Sort categories alphabetically
      const sortedCategories = Object.keys(categoryMovements).sort();
      
      // Calculate grand totals
      const grandTotals = {
        openingBalance: 0,
        additions: 0,
        depreciation: 0,
        disposals: 0,
        transfers: 0,
        closingBalance: 0
      };
      
      sortedCategories.forEach(category => {
        grandTotals.openingBalance += categoryMovements[category].openingBalance;
        grandTotals.additions += categoryMovements[category].additions;
        grandTotals.depreciation += categoryMovements[category].depreciation;
        grandTotals.disposals += categoryMovements[category].disposals;
        grandTotals.transfers += categoryMovements[category].transfers;
        grandTotals.closingBalance += categoryMovements[category].closingBalance;
      });

      // Format currency function
      const formatCurrencyWithDecimals = (value) => {
        if (!value && value !== 0) return '-';
        return value.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
        });
      };

      // Build HTML with single consolidated table
      let htmlContent = `
        <html>
        <head>
          <meta charset="UTF-8">
          <title>PPE Movement Schedule - Financial Year</title>
          <style>
            * { 
              font-family: 'Segoe UI', Arial, sans-serif; 
            }
            
            body {
              padding: 40px 30px;
              background: white;
            }
            
            /* Header Styles */
            .report-title {
              font-size: 20px;
              font-weight: bold;
              color: #1B4F72;
              text-align: center;
              margin-bottom: 8px;
            }
            
            .report-subtitle {
              font-size: 16px;
              font-weight: 600;
              color: #2C3E50;
              text-align: center;
              margin-bottom: 8px;
            }
            
            .report-date {
              font-size: 12px;
              color: #7F8C8D;
              text-align: center;
              margin-bottom: 30px;
            }
            
            /* Main Table */
            .main-table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 25px;
              margin-bottom: 30px;
              font-size: 12px;
            }
            
            .main-table th {
              background-color: #1B4F72;
              color: white;
              font-weight: bold;
              padding: 14px 10px;
              border: 1px solid #2471A3;
              text-align: center;
              vertical-align: middle;
              font-size: 13px;
            }
            
            .main-table td {
              border: 1px solid #BDC3C7;
              padding: 10px 8px;
              vertical-align: middle;
              font-size: 12px;
            }
            
            .category-row {
              background-color: #FFFFFF;
            }
            
            .category-row-alt {
              background-color: #F8F9F9;
            }
            
            .grand-total-row {
              background-color: #1B4F72;
              color: white;
              font-weight: bold;
              border-top: 2px solid #0E6251;
            }
            
            .grand-total-row td {
              font-weight: bold;
              font-size: 13px;
            }
            
            .text-right {
              text-align: right;
            }
            
            .text-left {
              text-align: left;
            }
            
            .text-center {
              text-align: center;
            }
            
            .currency {
              font-family: 'Courier New', monospace;
              font-weight: normal;
            }
            
            .negative {
              color: #E74C3C;
            }
            
            /* Summary Statistics Cards - Improved Spacing */
            .stats-container {
              display: flex;
              gap: 25px;
              margin-top: 30px;
              margin-bottom: 30px;
              justify-content: space-between;
            }
            
            .stat-card {
              flex: 1;
              background-color: #F8F9FA;
              border: 1px solid #DEE2E6;
              border-radius: 8px;
              padding: 20px;
              box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            }
            
            .stat-card-title {
              font-size: 14px;
              font-weight: bold;
              color: #1B4F72;
              margin-bottom: 15px;
              padding-bottom: 8px;
              border-bottom: 2px solid #1ABC9C;
              display: inline-block;
            }
            
            .stat-item {
              font-size: 13px;
              margin: 12px 0;
              line-height: 1.6;
            }
            
            .stat-label {
              font-weight: 600;
              color: #2C3E50;
              display: inline-block;
              min-width: 140px;
            }
            
            .stat-value {
              color: #1B4F72;
              font-weight: 500;
            }
            
            /* Footer Notes - Larger Font */
            .footer {
              margin-top: 35px;
              padding: 20px;
              background-color: #FEF9E7;
              border-left: 5px solid #F39C12;
              border-radius: 4px;
              font-size: 12px;
              line-height: 1.8;
            }
            
            .footer strong {
              font-size: 13px;
              color: #2C3E50;
            }
            
            .footer p {
              margin: 8px 0;
            }
            
            /* Signature Section */
            .signature-section {
              margin-top: 50px;
              padding-top: 30px;
              border-top: 2px solid #BDC3C7;
              display: flex;
              justify-content: space-between;
              gap: 30px;
            }
            
            .signature-line {
              flex: 1;
            }
            
            .signature-line .line {
              border-bottom: 1px solid #000;
              margin-top: 35px;
              margin-bottom: 8px;
            }
            
            .signature-line p {
              margin: 8px 0;
              font-size: 11px;
            }
            
            .signature-line strong {
              font-size: 12px;
            }
            
            /* Watermark */
            .watermark {
              font-size: 10px;
              color: #95A5A6;
              text-align: center;
              margin-top: 30px;
              padding-top: 15px;
              border-top: 1px dotted #BDC3C7;
            }
            
            /* Reconciliation Section */
            .reconciliation {
              background-color: #E8F8F5;
              padding: 20px;
              margin-top: 25px;
              border-radius: 4px;
              font-size: 13px;
              line-height: 2;
            }
            
            .reconciliation strong {
              font-size: 14px;
              color: #0E6251;
            }
          </style>
        </head>
        <body>
          <div class="report-title">
            PROPERTY, PLANT & EQUIPMENT (PPE)
          </div>
          <div class="report-subtitle">
            MOVEMENTS FOR THE YEAR ENDED ${formatDisplayDate(financialYearEndDate)}
          </div>
          <div class="report-date">
            Prepared in accordance with IFRS/IAS 16 | All amounts in Namibian Dollars (N$)
          </div>
          
          <!-- Single Consolidated Table -->
          <table class="main-table">
            <thead>
              <tr>
                <th style="width: 70%;">MOVEMENTS FOR THE YEAR ENDED ${formatDisplayDate(financialYearEndDate)}</th>
                <th style="width: 5%;">Carrying Amount at<br/>${previousPeriodEnd}</th>
                <th style="width: 5%;">ADDITIONS<br/>(N$)</th>
                <th style="width: 5%;">DEPRECIATION<br/>(N$)</th>
                <th style="width: 5%;">DISPOSALS<br/>(N$)</th>
                <th style="width: 5%;">TRANSFERS<br/>(N$)</th>
                <th style="width: 5%;">Carrying Amount at<br/>${currentPeriodEnd}</th>
              </tr>
            </thead>
            <tbody>
      `;
      
      // Add rows for each category
      let rowIndex = 0;
      for (const category of sortedCategories) {
        const data = categoryMovements[category];
        const rowClass = rowIndex % 2 === 0 ? 'category-row' : 'category-row-alt';
        
        htmlContent += `
          <tr class="${rowClass}">
            <td class="text-left"><strong>${category}</strong></td>
            <td class="text-right currency">${formatCurrencyWithDecimals(data.openingBalance)}</td>
            <td class="text-right currency">${formatCurrencyWithDecimals(data.additions)}</td>
            <td class="text-right currency ${data.depreciation > 0 ? 'negative' : ''}">(${formatCurrencyWithDecimals(data.depreciation)})</td>
            <td class="text-right currency ${data.disposals > 0 ? 'negative' : ''}">${data.disposals > 0 ? `(${formatCurrencyWithDecimals(data.disposals)})` : '-'}</td>
            <td class="text-right currency">${data.transfers > 0 ? formatCurrencyWithDecimals(data.transfers) : '-'}</td>
            <td class="text-right currency"><strong>${formatCurrencyWithDecimals(data.closingBalance)}</strong></td>
          </tr>
        `;
        rowIndex++;
      }
      
      // Add Grand Total Row
      htmlContent += `
          <tr class="grand-total-row">
            <td class="text-left"><strong>GRAND TOTAL - ALL CATEGORIES</strong></td>
            <td class="text-right currency"><strong>${formatCurrencyWithDecimals(grandTotals.openingBalance)}</strong></td>
            <td class="text-right currency"><strong>${formatCurrencyWithDecimals(grandTotals.additions)}</strong></td>
            <td class="text-right currency"><strong>(${formatCurrencyWithDecimals(grandTotals.depreciation)})</strong></td>
            <td class="text-right currency"><strong>${grandTotals.disposals > 0 ? `(${formatCurrencyWithDecimals(grandTotals.disposals)})` : '-'}</strong></td>
            <td class="text-right currency"><strong>${grandTotals.transfers > 0 ? formatCurrencyWithDecimals(grandTotals.transfers) : '-'}</strong></td>
            <td class="text-right currency"><strong>${formatCurrencyWithDecimals(grandTotals.closingBalance)}</strong></td>
          </tr>
      `;
      
      htmlContent += `
            </tbody>
          </table>
      `;
      
      // Add Reconciliation Section
      htmlContent += `
        <div class="reconciliation">
          <strong>📊 MOVEMENTS RECONCILIATION:</strong><br/>
          Opening Balance (${previousPeriodEnd}): ........................................................................ N$ ${formatCurrencyWithDecimals(grandTotals.openingBalance)}<br/>
          + Additions: .............................................................................................................. N$ ${formatCurrencyWithDecimals(grandTotals.additions)}<br/>
          - Depreciation: ........................................................................................................ N$ ${formatCurrencyWithDecimals(grandTotals.depreciation)}<br/>
          - Disposals: .............................................................................................................. N$ ${formatCurrencyWithDecimals(grandTotals.disposals)}<br/>
          +/- Transfers: ............................................................................................................ N$ ${formatCurrencyWithDecimals(grandTotals.transfers)}<br/>
          <strong style="font-size: 14px;">= Closing Balance (${currentPeriodEnd}): ................................................................. N$ ${formatCurrencyWithDecimals(grandTotals.closingBalance)}</strong>
        </div>
      `;
      
      // Add Summary Statistics - Improved spacing, removed asset count
      htmlContent += `
        <div class="stats-container">
          <div class="stat-card">
            <div class="stat-card-title">📈 FINANCIAL SUMMARY</div>
            <div class="stat-item">
              <span class="stat-label">Total Additions:</span>
              <span class="stat-value">N$ ${formatCurrencyWithDecimals(grandTotals.additions)}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Total Depreciation:</span>
              <span class="stat-value">N$ ${formatCurrencyWithDecimals(grandTotals.depreciation)}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Net Movement:</span>
              <span class="stat-value">N$ ${formatCurrencyWithDecimals(grandTotals.additions - grandTotals.depreciation - grandTotals.disposals)}</span>
            </div>
          </div>
          
          <div class="stat-card">
            <div class="stat-card-title">📊 KEY RATIOS</div>
            <div class="stat-item">
              <span class="stat-label">Depreciation Rate:</span>
              <span class="stat-value">${grandTotals.openingBalance > 0 ? ((grandTotals.depreciation / grandTotals.openingBalance) * 100).toFixed(2) : 0}%</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Reinvestment Rate:</span>
              <span class="stat-value">${grandTotals.depreciation > 0 ? ((grandTotals.additions / grandTotals.depreciation) * 100).toFixed(2) : 0}%</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Disposal Rate:</span>
              <span class="stat-value">${grandTotals.openingBalance > 0 ? ((grandTotals.disposals / grandTotals.openingBalance) * 100).toFixed(2) : 0}%</span>
            </div>
          </div>
          
          <div class="stat-card">
            <div class="stat-card-title">💰 VALUE SUMMARY</div>
            <div class="stat-item">
              <span class="stat-label">Opening Balance:</span>
              <span class="stat-value">N$ ${formatCurrencyWithDecimals(grandTotals.openingBalance)}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Closing Balance:</span>
              <span class="stat-value">N$ ${formatCurrencyWithDecimals(grandTotals.closingBalance)}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Value Change:</span>
              <span class="stat-value">${((grandTotals.closingBalance - grandTotals.openingBalance) / grandTotals.openingBalance * 100).toFixed(2)}%</span>
            </div>
          </div>
        </div>
      `;
      
      // Footer Notes - Larger font size
      htmlContent += `
        <div class="footer">
          <strong>📋 NOTES TO THE PPE MOVEMENT SCHEDULE:</strong><br/>
          <p>1. <strong>Opening Balance</strong> represents the carrying amount at the beginning of the financial year (${previousPeriodEnd})</p>
          <p>2. <strong>Additions</strong> include all asset acquisitions during the financial year</p>
          <p>3. <strong>Depreciation</strong> is calculated based on the straight-line method over estimated useful lives</p>
          <p>4. <strong>Disposals</strong> represent assets sold, scrapped, or otherwise disposed during the year</p>
          <p>5. <strong>Transfers</strong> include reclassifications between asset categories</p>
          <p>6. <strong>Closing Balance</strong> is the carrying amount at year end (${currentPeriodEnd})</p>
          <p>7. All amounts are presented in Namibian Dollars (N$)</p>
        </div>
        
        <div class="signature-section">
          <div class="signature-line">
            <strong>Prepared by:</strong>
            <div class="line"></div>
            <p>Name: _________________________</p>
            <p>Title: _________________________</p>
            <p>Date: _________________________</p>
          </div>
          <div class="signature-line">
            <strong>Reviewed by:</strong>
            <div class="line"></div>
            <p>Name: _________________________</p>
            <p>Title: _________________________</p>
            <p>Date: _________________________</p>
          </div>
          <div class="signature-line">
            <strong>Approved by:</strong>
            <div class="line"></div>
            <p>Name: _________________________</p>
            <p>Title: _________________________</p>
            <p>Date: _________________________</p>
          </div>
        </div>
        
        <div class="watermark">
          Generated on: ${new Date().toLocaleString()} | Audit Trail ID: PPE-${new Date().getTime()} | IFRS/IAS 16 Compliant
        </div>
      </body></html>`;

      // Create and download Excel file
      const blob = new Blob([htmlContent], { 
        type: 'application/vnd.ms-excel' 
      });
      
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const yearEndFormatted = financialYearEndDate.toISOString().split('T')[0];
      link.setAttribute('href', url);
      link.setAttribute('download', `PPE_Movement_Schedule_${yearEndFormatted}.xls`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      toast.success(`PPE Movement Schedule exported successfully`);
    } catch (error) {
      console.error('PPE Movement Schedule Export error:', error);
      toast.error("Failed to export PPE Movement Schedule");
    }
  };

  // Helper functions for status text
  const getDeliveredStatusText = (status) => {
    const statusMap = {
      0: 'Not Delivered',
      1: 'Partially Delivered',
      2: 'Fully Delivered'
    };
    return statusMap[status] || 'Not Delivered';
  };

  const getStatusText = (status) => {
    const statusMap = {
      0: 'Available',
      1: 'Unavailable',
      2: 'Damaged'
    };
    return statusMap[status] || 'Available';
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 70 },
    { field: "invoiceNumber", headerName: "Invoice Number", flex: 1, minWidth: 120 },
    { field: "sku", headerName: "SKU", flex: 1, minWidth: 120 },
    { field: "type", headerName: "Type", flex: 1, minWidth: 120 },
    { field: "description", headerName: "Description", flex: 1, minWidth: 120 },
    { field: "category", headerName: "Category", flex: 1, minWidth: 120 },
    { field: "categoryType", headerName: "Category Type", flex: 1, minWidth: 120 },
    { field: "verification_period", headerName: "Verification Period", flex: 1, minWidth: 120 },
    { field: "location", headerName: "Location", flex: 1, minWidth: 120 },
    { field: "serialNumber", headerName: "Serial Number", flex: 1, minWidth: 120 },
    { field: "purchaseddate", headerName: "Purchased Date", flex: 1, minWidth: 120 },
    { field: "suplier", headerName: "Supplier", flex: 1, minWidth: 120 },
    { field: "quantity", headerName: "Quantity", flex: 1, minWidth: 120, renderCell: (params) => params.row.quantity || '0' },
    { field: "deliveredDate", headerName: "Delivered Date", flex: 1, minWidth: 120 },
    { field: "currentPeriodEnd", headerName: "Current Period End", flex: 1, minWidth: 120 },
    { field: "lifeSpanPeriod", headerName: "Useful Life (Years)", flex: 1, minWidth: 120 },
    { field: "brought_in_use", headerName: "Action Date", flex: 1, minWidth: 120 },
    { field: "depreciationMethod", headerName: "Depreciation Method", flex: 1, minWidth: 120 },
    { field: "depreciationRate", headerName: "Rate (%)", flex: 1, minWidth: 120 },
    { field: "costprice", headerName: "Cost Price (N$)", flex: 1, minWidth: 130, renderCell: (params) => params.row.costprice ? parseFloat(params.row.costprice).toLocaleString() : '0' },
    { field: "additions", headerName: "Additions (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.additions ? parseFloat(params.row.additions).toLocaleString() : '0' },
    
    { field: "actualValue", headerName: "Closing Value (N$)", flex: 1, minWidth: 120, renderCell: (params) => {
      const actual = parseFloat(params.row.actualValue) || 0;
      return(
        <Typography variant="h4" fontWeight={700} paddingTop={'.7rem'} color={actual > 0 ? colors.orange[400] : colors.dark[400]}>
          {actual.toLocaleString()}
        </Typography>
      )
    } },
    { field: "salvageValue", headerName: "Residual Value (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.salvageValue ? parseFloat(params.row.salvageValue).toLocaleString() : '0' },
    { field: "depreciationValue", headerName: "Depreciation Value (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.depreciationValue ? parseFloat(params.row.depreciationValue).toLocaleString() : '0' },
    { field: "opening_depr", headerName: "Opening Depreciation (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.opening_depr ? parseFloat(params.row.opening_depr).toLocaleString() : '0' },
    { field: "current_period_depr", headerName: "Current Period Depreciation (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.current_period_depr ? parseFloat(params.row.current_period_depr).toLocaleString() : '0' },
    { field: "accumulated_depr", headerName: "Accumulated Depreciation (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.accumulated_depr ? parseFloat(params.row.accumulated_depr).toLocaleString() : '0' },
    { field: "carrying_value", headerName: "Carrying Value (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.carrying_value ? parseFloat(params.row.carrying_value).toLocaleString() : '0' },
    { field: "book_value", headerName: "Book Value (N$)", flex: 1, minWidth: 120, renderCell: (params) => params.row.book_value ? parseFloat(params.row.book_value).toLocaleString() : '0' },
    { field: "product_condition", headerName: "Condition", flex: 1, minWidth: 120 },
    {
      field: "deliveredStatus",
      headerName: "Delivered Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        
        const statusColor = {
          'Not Delivered': colors.red[400],
          'Patially Delivered': colors.orange[400],
          'Fully Delivered': colors.blue[400]
        };
        return (
          <Typography color={statusColor[params.row.deliveredStatus]}>
            {params.row.deliveredStatus || 'Not Delivered'}
          </Typography>
        );
      }
    },
    {
      field: "image",
      headerName: "Image",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <img
          src={`https://mindsinaction.com.na/assets/media/pictures/${params.row.image}` || "https://via.placeholder.com/40"}
          alt="Product"
          style={{ width: 40, height: 40 }}
        />
      )
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const statusText = {
          0: 'Available',
          1: 'Unavailable',
          2: 'Damaged'
        };
        const statusColor = {
          0: colors.blue[400],
          1: colors.orange[400],
          2: colors.red[400]
        };
        return (
          <Typography color={statusColor[params.row.status]}>
            {statusText[params.row.status] || 'Available'}
          </Typography>
        );
      }
    },
    { field: "comment", headerName: "Comment", flex: 1, minWidth: 120 },
    { field: "assignedTo", headerName: "Assigned To", flex: 1, minWidth: 120,
        renderCell: (params) => (
        <Box display="flex" alignItems={'center'} justifyContent={'center'} padding={'.5rem 0'}>
          {params.value ? (
            <img
                src={
                    `https://mindsinaction.com.na/assets/media/pictures/${staffs.find((s) => s.Id === params.value)?.image}` ||
                    "https://via.placeholder.com/40"
                }
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: "50%", marginRight: 8 }}
            />
          ):(
            <Typography color={colors.dark[400]}>Unassigned</Typography>
          )}
            
        </Box>
      )
    },
    {
      field: "isVerified",
      headerName: "Is Verified",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Box>
          {params.row.isVerified === 0 ? <CheckBoxIcon color="success" /> : <CloseIcon color="error" />}
        </Box>
      )
    },
    { field: "verifiedDate", headerName: "Verified Date", flex: 1, minWidth: 120 },
    { field: "lastDepreciationDate", headerName: "Last Depreciation Date", flex: 1, minWidth: 120 },
    { field: "nextDepreciationDate", headerName: "Next Depreciation Date", flex: 1, minWidth: 120 },
    { field: "dateCreated", headerName: "Date Created", flex: 1, minWidth: 120 },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box display="flex" gap="8px">

          <IconButton
            onClick={() => downloadSkuQR(params.row)}
            sx={{ color: colors.green[400] }}
          >
            <QrCodeIcon />
          </IconButton>

          <IconButton
            onClick={() => handleEditClick(params.row)}
            sx={{ color: colors.blue[400] }}
          >
            <EditNoteOutlinedIcon />
          </IconButton>

          <IconButton
            onClick={() => handleDeleteClick(params.row)}
            sx={{ color: colors.red[400] }}
          >
            <DeleteForeverOutlinedIcon />
          </IconButton>

        </Box>
      ),
    }
  ];

  const NoDataOverlay = () => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        color={colors.dark[400]}
      >
        <img
          src={Nodata}
          alt="No data"
          style={{ width: 150, marginBottom: 16 }}
        />
        <Typography variant="h6">No inventory items available</Typography>
      </Box>
    );
  };

  return (
    <Box m={"10px"}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Add/Edit Dialog */}
      <Dialog
        open={openEditDialog || openAddDialog}
        onClose={() => {
          setOpenEditDialog(false);
          setOpenAddDialog(false);
          setSelectedItem(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{selectedItem ? "Edit Asset Item" : "Add New Asset Item"}</DialogTitle>
        <DialogContent>
          <Form onSubmit={handleSubmit} style={{ width: "100%", padding: "1rem" }}>
            <Box display={"flex"} gap={"1rem"} width={"100%"} mb={"1rem"} flexWrap="wrap">
              
              <TextField
                style={{ width: "100%" }}
                id="description"
                name="description"
                label="Description"
                variant="standard"
                value={formData.description}
                onChange={handleFormChange}
                minRows={6}
                maxRows={12}
                multiline
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="currentPeriodEnd"
                name="currentPeriodEnd"
                label="Current Period End"
                type="date"
                variant="standard"
                value={formData.currentPeriodEnd}
                onChange={handleFormChange}
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="invoiceNumber"
                name="invoiceNumber"
                label="Invoice Number"
                variant="standard"
                value={formData.invoiceNumber}
                onChange={handleFormChange}
                required
              />
              
              <TextField
                style={{ width: "48%" }}
                id="sku"
                name="sku"
                label="SKU"
                variant="standard"
                value={formData.sku}
                InputProps={{ readOnly: true }}
              />
              <TextField
                select
                style={{ width: "48%" }}
                id="type"
                name="type"
                label="Type"
                variant="standard"
                value={formData.type}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select Type</option>
                <option value="purchased">Purchased</option>
                <option value="donated">Donated</option>
                <option value="constructed">Constructed</option>
              </TextField>

              <TextField
                select
                style={{ width: "48%" }}
                id="category"
                name="category"
                label="Category"
                variant="standard"
                value={formData.category}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select Category</option>
                <option value="Land & Buildings">Land & Buildings</option>
                <option value="Electronics">Electronics</option>
                <option value="Furniture">Furniture</option>
                <option value="Office Supplies">Office Supplies</option>
                <option value="Vehicle">Vehicle</option>
                <option value="Tools & Equipment">Tools & Equipment</option>
                <option value="Others">Others</option>
              </TextField>
              <TextField
                select
                style={{ width: "48%" }}
                id="categoryType"
                name="categoryType"
                label="Category Type"
                variant="standard"
                value={formData.categoryType}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select Category Type</option>
                <option value="Laptop">Laptop</option>  
                <option value="Desktop">Desktop</option>
                <option value="Monitor">Monitor</option>
                <option value="Printer">Printer</option>
                <option value="Chair">Chair</option>
                <option value="Table">Table</option>
                <option value="Stationery">Stationery</option>
                <option value="Car">Car</option>
                <option value="Van">Van</option>
                <option value="Truck">Truck</option>
                <option value="Buss">Buss</option>
                <option value="Power Tools">Power Tools</option>
                <option value="Hand Tools">Hand Tools</option>
                <option value="Robotics Kit">Robotics Kit</option>
                <option value="Electronics Kit">Electronics Kit</option>
                <option value="Twin Science Kit">Twin Science Kit</option>
                <option value="Mechatronics Kit">Mechatronics Kit</option>
                <option value="Charger">Charger</option>
                <option value="Others">Others</option>
              </TextField>
              <TextField
                style={{ width: "48%" }}
                id="broaght_in_use"
                name="broaght_in_use"
                label="Brought In Use"
                type="date"
                variant="standard"
                value={formData.broaght_in_use}
                onChange={handleFormChange}
                required
              />
              <TextField
                select
                style={{ width: "48%" }}
                id="verification_period"
                name="verification_period"
                label="Verification Period"
                variant="standard"
                value={formData.verification_period}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select Verification Period</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </TextField>
              <TextField
                style={{ width: "48%" }}
                id="location"
                name="location"
                label="Location"
                variant="standard"
                value={formData.location}
                onChange={handleFormChange}
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="serialNumber"
                name="serialNumber"
                label="Serial Number"
                variant="standard"
                value={formData.serialNumber}
                onChange={handleFormChange}
              />
              <TextField
                style={{ width: "48%" }}
                id="purchaseddate"
                name="purchaseddate"
                label="Purchased Date"
                type="date"
                variant="standard"
                value={formData.purchaseddate}
                onChange={handleFormChange}
                required
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                style={{ width: "48%" }}
                id="suplier"
                name="suplier"
                label="Supplier"
                variant="standard"
                value={formData.suplier}
                onChange={handleFormChange}
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="quantity"
                name="quantity"
                label="Quantity"
                type="number"
                variant="standard"
                value={formData.quantity}
                onChange={handleFormChange}
                required
              />

              <TextField
                style={{ width: "48%" }}
                id="deliveredDate"
                name="deliveredDate"
                label="Delivered Date"
                type="date"
                variant="standard"
                value={formData.deliveredDate}
                onChange={handleFormChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                style={{ width: "48%" }}
                id="costprice"
                name="costprice"
                label="Cost Price (N$)"
                type="number"
                variant="standard"
                value={formData.costprice}
                onChange={handleFormChange}
                required
              />
              <TextField
                style={{ width: "48%" }}
                id="additions"
                name="additions"
                label="Additions"
                type="number"
                variant="standard"
                value={formData.additions}
                onChange={handleFormChange}
                required
              />
              <TextField
                select
                style={{ width: "48%" }}
                id="lifeSpanPeriod"
                name="lifeSpanPeriod"
                label="Life Span Period"
                variant="standard"
                value={formData.lifeSpanPeriod}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select</option>
                <option value="1">1 Year</option>
                <option value="2">2 Years</option>
                <option value="3">3 Years</option>
                <option value="4">4 Years</option>
                <option value="5">5 Years</option>
                <option value="6">6 Years</option>
                <option value="7">7 Years</option>
                <option value="8">8 Years</option>
                <option value="9">9 Years</option>
                <option value="10">10 Years</option>
              </TextField>

              < TextField
                select
                style={{ width: "48%" }}
                id="depreciationMethod"
                name="depreciationMethod"
                label="Depreciation Method"
                variant="standard"
                value={formData.depreciationMethod}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select</option>
                <option value="straight_line">Straight Line</option>
                <option value="declining_balance">Declining Balance</option>
                <option value="sum_of_years_digits">Sum of Years' Digits</option>
                <option value="units_of_production">Units of Production</option>
              </TextField>

              <TextField
                style={{ width: "48%" }}
                id="depreciationRate"
                name="depreciationRate"
                label="Rate (%)"
                type="number"
                variant="standard"
                value={formData.depreciationRate}
                onChange={handleFormChange}
                required
              />

              <TextField
                select
                style={{ width: "48%" }}
                id="product_condition"
                name="product_condition"
                label="Condition"
                variant="standard"
                value={formData.product_condition}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select</option>
                <option value="New">New</option>
                <option value="Used">Used</option>
                <option value="Refurbished">Refurbished</option>
                <option value="Damaged">Damaged</option>
                <option value="Discarded">Discarded</option>
              </TextField>
              <TextField
                select
                style={{ width: "48%" }}
                id="deliveredStatus"
                name="deliveredStatus"
                label="Delivered Status"
                variant="standard"
                value={formData.deliveredStatus}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select</option>
                <option value="1">Not Delivered</option>
                <option value="2">Partially Delivered</option>
                <option value="3">Fully Delivered</option>
              </TextField>
              
              <TextField select name="assignedTo" label="Assigned To" style={{ width: "48%" }}
                variant="standard"
                value={formData.assignedTo} onChange={handleFormChange} SelectProps={{ native: true }}>
                <option value="">Select User</option>
                  {staffs.map((user) => (
                    <option key={user.Id} value={user.Id}>
                      {user.FirstName} {user.LastName}
                    </option>
                ))}
              </TextField>
              <TextField
                select
                style={{ width: "48%" }}
                id="isVerified"
                name="isVerified"
                label="Is Verified"
                variant="standard"
                value={formData.isVerified}
                onChange={handleFormChange}
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select Verification Status</option>
                <option value="0">Yes</option>
                <option value="1">No</option>
              </TextField>
              <TextField
                style={{ width: "48%" }}
                id="verifiedDate"
                name="verifiedDate"
                label="Verified Date"
                type="date"
                variant="standard"
                value={formData.verifiedDate}
                onChange={handleFormChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                style={{ width: "100%" }}
                id="comment"
                name="comment"
                label="Comment"
                variant="standard"
                value={formData.comment}
                onChange={handleFormChange}
                multiline
                rows={4}
              />
              {/* // checkbox for status */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.status === "0"}
                    onChange={handleFormChange}
                    name="status"
                  />
                }
                label={formData.status !== "0" ? "Unavailable" : "Available"}
              />
            </Box>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenEditDialog(false);
              setOpenAddDialog(false);
              setSelectedItem(null);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            sx={{ backgroundColor: colors.blue[400] }}
            variant="contained"
            endIcon={<SendIcon />}
          >
            {selectedItem ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this asset item?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button
            onClick={handleDeleteConfirm}
            sx={{ backgroundColor: colors.red[400] }}
            variant="contained"
            startIcon={<DeleteIcon />}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Box mb={"30px"} ml={"15px"} mr={"15px"} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
        <Box flex={1}>
          <Typography
            variant="h4"
            color={colors.dark[400]}
            fontWeight={"bold"}
            sx={{ mb: "5px" }}
          >
            Asset Management
          </Typography>
          <Typography variant="h5" color={colors.blue[400]}>
            Manage asset items
          </Typography>
        </Box>
        <Box display="flex" gap="1rem">
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={exportPPEExcel}
            sx={{
              borderColor: colors.green[400],
              color: colors.green[400],
              '&:hover': {
                backgroundColor: colors.green[50],
                borderColor: colors.green[500],
              }
            }}
          >
            Export PPE
          </Button>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={exportAccountingExcel}
            sx={{
              borderColor: colors.green[400],
              color: colors.green[400],
              '&:hover': {
                backgroundColor: colors.green[50],
                borderColor: colors.green[500],
              }
            }}
          >
            Export Auditing
          </Button>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={exportToExcel}
            sx={{
              borderColor: colors.green[400],
              color: colors.green[400],
              '&:hover': {
                backgroundColor: colors.green[50],
                borderColor: colors.green[500],
              }
            }}
          >
            Export Excel
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            sx={{
              backgroundColor: colors.blue[400],
              '&:hover': {
                backgroundColor: colors.blue[500],
              }
            }}
          >
            Add Asset Item
          </Button>
        </Box>
      </Box>
      <Divider component="" />
      <Box sx={{ height: 'calc(100vh - 300px)', width: "100%" }} backgroundColor={colors.dark[300]} padding={".2rem"} mt={"1rem"}>
        <DataGrid
          rows={items}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          sx={{
            border: "none",
            ".MuiDataGrid-cell": {
              borderBottom: "none",
              backgroundColor: "none"
            },
            ".MuiDataGrid-toolbarContainer": {
              padding: "10px",
              backgroundColor: colors.primary[900],
              borderBottom: "none",
            },
            ".MuiDataGrid-quickFilter": {
              padding: "8px",
              borderRadius: "4px",
              border: `1px solid ${colors.primary[100]}`,
            },
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: colors.primary[900],
            },
            ".MuiDataGrid-footerContainer": {
              backgroundColor: colors.primary[900],
            },
          }}
          slots={{
            toolbar: () => (
              <div>
                <GridToolbarQuickFilter />
              </div>
            ),
            noRowsOverlay: NoDataOverlay,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: {
                debounceMs: 500,
                placeholder: "Search...",
              },
            },
          }}
        />
      </Box>
      <Box sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 1rem',
        marginTop: '1rem'
      }}> 
        <Typography variant="h3" color={colors.dark[400]} fontWeight={"bold"}>
          Total Asset Value:
        </Typography>
        <Typography variant="h3" color={colors.green[400]} fontWeight={"bold"}>
          N${
            items
              .filter(
                (item) =>
                  !["discarded", "damaged", "refurbished"].includes(
                    (item.product_condition || "").toLowerCase()
                  )
              )
              .reduce(
                (total, item) =>
                  total +
                  (parseFloat(item.actualValue || 0) *
                    parseInt(item.quantity || "0")),
                0
              )
              .toLocaleString()
          }
        </Typography>
      </Box>
      <Box sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 1rem',
        marginTop: '1rem'
      }}> 
        <Typography variant="h5" color={colors.orange[400]} fontWeight={"bold"}>
          Total Cost Price:
        </Typography>
        <Typography variant="h5" color={colors.orange[400]} fontWeight={"bold"}>
          N${
            items
              .filter(
                (item) =>
                  !["discarded", "damaged", "refurbished"].includes(
                    (item.product_condition || "").toLowerCase()
                  )
              )
              .reduce(
                (total, item) =>
                  total +
                  (parseFloat(item.costprice || 0) *
                    parseInt(item.quantity || "0")),
                0
              )
              .toLocaleString()
          }
        </Typography>
      </Box>
    </Box>
  );
};

export default Inventory;